<p-dialog
  #dialogIxNotification
  (onHide)="this.hide($event)"
  [autoZIndex]="true"
  [contentStyle]="{ overflow: 'visible' }"
  [closable]="false"
  [maskStyle]="{ overflow: 'auto' }"
  [modal]="true"
  [style]="{ 'max-width': '80rem' }"
  [visible]="true"
  appendTo="body"
  styleClass="w-11 dialog-max-width"
>
  <ng-template pTemplate="header">
    <ul
      class="list-none p-0 m-0 flex flex-row justify-content-between align-items-center flex-grow-1"
    >
      <li class="flex justify-content-start mr-1 text-2xl lg:text-xl align-items-center">
        <i class="fa fa-exclamation-triangle mr-1"></i>
        <div class="hidden lg:block px-2">
          {{ this.ixNgValidationService.validationRecordTitle }}
        </div>
      </li>
      <li
        class="flex justify-content-between lg:justify-content-end align-items-center p-toolbar-group-right gap-1"
      >
        <div class="p-input-icon-left">
          <i
            class="fa fa-search flex-center-vertically abs-center-icon icon-corner-left"
            [ngClass]="{
              'primaryColorB primaryTextColorReverse': (this.searchValue.length || 0) > 0,
            }"
          ></i>
          <input
            ixInput
            type="search"
            pInputText
            size="20"
            placeholder="Išči po tabeli..."
            (keyup)="this.onTableSearch($event)"
            class="p-inputtext-sm"
          />
        </div>
        <div class="flex flex-nowrap gap-1">
          <p-button
            [label]="!IxNgHtmlStaticUtils.mobile ? 'Izvozi v Excel' : undefined"
            (click)="this.exportToExcel()"
            icon="fa fa-file-excel"
            size="small"
          />
          <p-button
            [label]="!IxNgHtmlStaticUtils.mobile ? 'Zapri' : undefined"
            (click)="this.hide($event, false)"
            icon="fa fa-times"
            size="small"
          />
        </div>
      </li>
    </ul>
  </ng-template>
  <p-table
    ixTableShortcuts
    #dt
    ixTable
    [value]="this.tempValidationRecordList()"
    sortMode="multiple"
    [multiSortMeta]="multiSortMeta"
    [ixSearchFunction]="this.searchFunction()"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="splited-table-header">
          <div class="splited-table-wrapper">
            <div>Tip</div>
          </div>
        </th>
        <th class="splited-table-header">
          <div class="splited-table-wrapper">
            <div>Oznaka</div>
          </div>
        </th>
        <th class="splited-table-header">
          <div class="splited-table-wrapper">
            <div>Opis</div>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      @if (this.showGroupName(row, rowIndex)) {
        <tr>
          <td colspan="3" style="font-weight: bold">
            {{ row?.uiGroupName }}
          </td>
        </tr>
      }
      <tr>
        <td>
          <div style="text-align: center">
            <i
              class="fa {{ getMessageType(row.type) }}"
              [style.color]="getMessageColor(row.type)"
              [style.vertical-align]="'bottom'"
            >
            </i>
          </div>
        </td>
        <td class="{{ row.type }}">
          {{ row.code }}
        </td>
        <td class="{{ row.type }}" [innerText]="row.errorMessage"></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr class="p-widget-header" style="background-color: rgb(230, 230, 230)">
        <td colspan="3" style="text-align: center">
          <span style="font-weight: bold; padding-right: 30px"
            >Skupaj blokad: {{ this.errorCount() }}</span
          >
          <span style="font-weight: bold">Skupaj opozoril: {{ this.warningCount() }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="flex justify-content-end mt-2">
    <p-button
      [style.display]="
        this.ixNgValidationService.validationRecordIgnoreAction === undefined ||
        (this.errorCount() === 0 && this.warningCount() === 0) ||
        !this.validationDialogService.showPrezriOpozorilaButton
          ? 'none'
          : 'inline-block'
      "
      (click)="this.ignore($event)"
      iconPos="top"
      label="Prezri opozorila"
      icon="fa-regular fa-triangle-exclamation"
      [outlined]="true"
      severity="warn"
      size="small"
    />
  </div>
</p-dialog>
